import { render } from "./ContactSuccessPage.vue?vue&type=template&id=5ac2fb87&scoped=true"
import script from "./ContactSuccessPage.vue?vue&type=script&lang=js"
export * from "./ContactSuccessPage.vue?vue&type=script&lang=js"

import "./ContactSuccessPage.vue?vue&type=style&index=0&id=5ac2fb87&scoped=true&lang=css"

import exportComponent from "/Users/czh/Desktop/czh/yog_website/lada/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac2fb87"]])

export default __exports__